import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from '@mui/material';
import { useLoading } from '../../hooks/useLoading';
import { useNotifications } from '../../hooks/useNotifications';
import { updateDocumentRepositoryFolder } from '../../constants/requests';

export default function RenameFolderDialog({
  open,
  folder,
  employeeId,
  onClose,
  onSaved
}) {
  const { request } = useLoading();
  const { showNotifications } = useNotifications();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName(folder?.name ?? '');
    }
  }, [open, folder]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const folderId = folder?._id ?? folder?.id;
    const trimmed = name?.trim() ?? '';
    if (!folderId) {
      showNotifications('error', 'Missing folder id', 4000);
      return;
    }
    if (!trimmed) {
      showNotifications('warning', 'Folder name is required', 3000);
      return;
    }

    setSaving(true);
    try {
      const response = await request(() =>
        updateDocumentRepositoryFolder(
          folderId,
          { name: trimmed, employeeId },
          employeeId
        )
      );

      if (response?.data?.success) {
        showNotifications('success', 'Folder updated', 3000);
        onClose();
        onSaved?.();
      } else {
        showNotifications(
          'error',
          response?.data?.message ?? 'Failed to update folder',
          5000
        );
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle>Rename folder</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Folder name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={saving}
            inputProps={{ maxLength: 255 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={saving}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
